import React, { useContext, useEffect, useState } from "react";
import { Route, useParams, Routes } from "react-router";
import moment from "moment";

import refreshIcon from "../../../../assets/images/refresh.svg";

import { PrimaryButton, TabButton } from "../../../atoms/Buttons";
import { H5, H6, P } from "../../../atoms/Texts";
import ActionPageHero from "../../../molecules/ActionPageHero";
import { toastError } from "../../../../shared/helpers";
import { Pill } from "../../../atoms/Badges/badge.ssn";
import CasesNav from "../../../molecules/CasesNav";

import {
  CaseNotePage,
  CaseOverviewPage,
  CaseSchedule,
} from "../../../templates/Case";
import UpdateCaseStatusModal from "../../../organisms/UpdateCaseStatusModal";
import { demoContext } from "../../../../shared/store/contexts";

import Joyride from "react-joyride";
import { useWalkthrough } from "../../../../shared/hooks/useWalkthrough";

const CaseDetailPage = () => {
  const { id: orgId, caseId } = useParams();
  const { cases } = useContext(demoContext);

  const [showUpdateCaseStatusModal, setShowUpdateCaseStatusModal] = useState(false);
  const toggleUpdateCaseStatusModal = () => {
    setShowUpdateCaseStatusModal(!showUpdateCaseStatusModal);
  };
  const specificCase = cases?.find((i) => i.id === caseId);

  const steps = [
    {
      target: ".change-status",
      content: "Click here to change the status of a case.",
    },
    {
      target: ".assign-case",
      content:
        "Click here to change the assign the case to a member of your organisation.",
    },
  ];

  const { joyrideProps } = useWalkthrough({
    steps,
    walkthroughKey: "case_detail_page",
    pageSpecific: true, // Each page tracks separately
  });

  return (
    <>
      <Joyride
        key={joyrideProps.run ? "walkthrough-active" : "walkthrough-inactive"}
        {...joyrideProps}
      />

      <main className="flex flex-col w-full" id="case-details">
        <ActionPageHero
          className="organization-container"
          title="Case"
          breadcrumb
          routes={[
            {
              title: "Cases",
              path: `/dashboard/organization/${orgId}/case-management`,
            },
            {
              title: `Jane Doe`,
              path: `/dashboard/organization/${orgId}/case-management/${caseId}`,
            },
          ]}
        />

        <section className="organization-container pb-10 flex-grow flex flex-col mt-6">
          <div>
            {specificCase && (
              <div className="grid md:grid-cols-2 gap-6  mb-4">
                <div className="bg-white flex items-center p-10">
                  <div
                    className="w-20 h-20 rounded-full flex items-center justify-center object-cover mb-2 profile-dropdown-child mr-8"
                    style={{ background: "#EAE7FE" }}
                  >
                    <H5
                      color="#12046D"
                      className="capitalize profile-dropdown-child"
                      fontSize="24px"
                    >
                      JD
                    </H5>
                  </div>
                  <div>
                    <div className="flex items-center">
                      <H5 color="#22202D">Jane Doe</H5>
                      <P color="#7D7B96" fontSize="14px" className="ml-3">
                        {specificCase?.caseNumber}
                      </P>
                    </div>
                    <div className="flex items-center mb-2">
                      <a
                        href={`mailto: ${specificCase?.referral?.user?.email}`}
                        className="mr-4"
                      >
                        <P color="#7D7B96" fontSize="14px" className="underline">
                          jane@gmail.co{" "}
                        </P>
                      </a>
                      {specificCase?.referral?.user?.phone && (
                        <a
                          href={`tel: ${specificCase?.referral?.user?.phone}`}
                          className="mr-4"
                        >
                          <P color="#7D7B96" fontSize="14px" className="underline">
                            +233 4575 489 222
                          </P>
                        </a>
                      )}
                    </div>
                    <P color="#B4B3C8" fontSize="14px">
                      Added {moment(specificCase?.createdAt).format("ll")}
                    </P>
                  </div>
                </div>
                <div className="bg-white px-8 py-6 flex items-center justify-between">
                  <div className="space-y-2">
                    <H6 color="#22202D">Status</H6>
                    <TabButton
                      p="10.5px 14px"
                      fontSize="14px"
                      color="#22202D"
                      className="flex items-center change-status"
                      onClick={toggleUpdateCaseStatusModal}
                    >
                      <img src={refreshIcon} alt="" className="w-4 h-4 mr-2" />
                      Change Status
                    </TabButton>

                    <Pill
                      borderRadius="4px"
                      p="4px 10px"
                      fontSize="14px"
                      className="capitalize"
                    >
                      {specificCase?.status}
                    </Pill>
                  </div>

                  <div>
                    <PrimaryButton className="assign-case">
                      Assign Case
                    </PrimaryButton>
                  </div>
                </div>
              </div>
            )}

            <CasesNav />

            <Routes>
              <Route
                element={<CaseNotePage details={specificCase} />}
                path="/notes"
              />

              <Route
                element={<CaseSchedule details={specificCase} />}
                path="/schedule"
              />

              <Route
                exact
                element={<CaseOverviewPage details={specificCase} />}
                path="/overview"
              />

              <Route
                exact
                element={<CaseOverviewPage details={specificCase} />}
                path="/"
              />
            </Routes>

            {showUpdateCaseStatusModal && (
              <UpdateCaseStatusModal
                _case={specificCase}
                closeModal={toggleUpdateCaseStatusModal}
              />
            )}
          </div>
        </section>
      </main>
    </>
  );
};

export default CaseDetailPage;
